<template>
  <accordion
    class="accordion-mobile"
    v-bind="childProps"
  >
    <template #head>
      <slot name="head" />
    </template>
    <template #content>
      <slot name="content" />
    </template>
  </accordion>
</template>

<script setup lang="ts">
  import {computed} from 'vue';
  import Accordion from '@/bps/components/accordion/accordion.vue';
  import {type AccordionProps} from '@/bps/components/accordion/accordion.vue';
  import {useIsMobile, type Breakpoint} from '@/bps/utilities/composables/isMobile/isMobile';

  interface AccordionMobileProps {
    mobileBreakpoint?: Breakpoint;
  }

  const props = withDefaults(defineProps<
    AccordionProps & AccordionMobileProps
  >(), {
    initialOpen: false,
    foldOut: false,
    useMaxHeight: true,
    anchor: null,
    mobileBreakpoint: 768
  });

  const {isMobile} = useIsMobile(props.mobileBreakpoint);

  const childProps = computed<AccordionProps>(() => {
    return {
      initialOpen: isMobile.value ? props.initialOpen : true,
      foldOut: isMobile.value ? props.foldOut : true,
      useMaxHeight: props.useMaxHeight,
      anchor: props.anchor
    };
  })
</script>
